/**
 * #MT-7546968 — view listagem Countback.
 * #MT-699B225 — evidência: histórico de todos os status (data/hora, posição, qtd,
 * operador, SKU, status) e quem liberou no saneamento.
 */

const STATUS_CLASS = {
	OK: 'cb-ok',
	DIVERGENTE: 'cb-div',
	BLOQUEADO_AUDITORIA: 'cb-blk',
	LIBERADO_GESTOR: 'cb-lib',
	CANCELADO: 'cb-can',
};

function esc(s) {
	return String(s ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

function fmtDt(v) {
	if (!v) return '';
	try {
		const d = new Date(v);
		if (Number.isNaN(d.getTime())) return String(v);
		// Evidência de auditoria: mesmo segundo exibido no relatório.
		return d.toLocaleString('pt-BR', {
			day: '2-digit', month: '2-digit', year: 'numeric',
			hour: '2-digit', minute: '2-digit', second: '2-digit',
		});
	} catch (_) {
		return String(v);
	}
}

export default async function(records) {
	return `
		<style>
			.view td { vertical-align: top; }
			.cb-badge { display:inline-block; padding:2px 7px; border-radius:3px;
				font-size:0.82em; font-weight:600; background:#e2e3e5; color:#383d41; }
			.cb-badge.cb-ok { background:#d4edda; color:#155724; }
			.cb-badge.cb-div { background:#fff3cd; color:#856404; }
			.cb-badge.cb-blk { background:#f8d7da; color:#721c24; }
			.cb-badge.cb-lib { background:#d1ecf1; color:#0c5460; }
			.cb-badge.cb-can { background:#e2e3e5; color:#383d41; }
			.bn_release_countback { cursor:pointer; }
			.view tr[data-id] { cursor:pointer; }
			.cb-prod { display:inline-block; max-width:16rem; overflow:hidden;
				text-overflow:ellipsis; white-space:nowrap; vertical-align:bottom; }
			.cb-note { max-width:18rem; white-space:normal; word-break:break-word; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Selecionar/desselecionar todos"></th>
					<th>Empresa</th>
					<th>Saída</th>
					<th>Pedido</th>
					<th>SKU / Produto</th>
					<th>Lote</th>
					<th>Posição</th>
					<th>Qtd sep.</th>
					<th>Esperado</th>
					<th>Informado</th>
					<th>Dif.</th>
					<th>Tent.</th>
					<th>Operador</th>
					<th>Data/hora</th>
					<th>Status</th>
					<th>Resolvido por</th>
					<th>Resolvido em</th>
					<th>Observação</th>
					<th>Ações</th>
				</tr>
			</thead>
			<tbody>
			` + (records || []).map((r) => {
				const companyNick = r.company_nick || r.company_id || '';
				const sku = r.product_sku || '';
				const pname = r.product_name || '';
				const prodText = sku ? `${sku} — ${pname}` : (pname || String(r.product_id || ''));
				const prod = esc(prodText);
				const blocked = r.status === 'BLOQUEADO_AUDITORIA';
				const badgeClass = STATUS_CLASS[r.status] || '';
				// data-id sem esc() em aspas — JSON.parse no crud exige aspas literais
				const dataId = JSON.stringify([String(r.company_id), Number(r.id)]);
				return `
				<tr data-id='${dataId.replace(/'/g, '&#39;')}'>
					<td><input type="checkbox"${this.isChecked(dataId)}></td>
					<td>${esc(companyNick)}</td>
					<td>${esc(r.output_id)}</td>
					<td>${esc(r.order_id ?? '')}</td>
					<td><span class="cb-prod" title="${prod}">${prod}</span></td>
					<td>${esc(r.lot_number || r.lot_id || '')}</td>
					<td>${esc(r.location_code || r.location_id || '')}</td>
					<td>${esc(r.picked_quantity)}</td>
					<td>${esc(r.expected_remaining_quantity)}</td>
					<td>${esc(r.informed_remaining_quantity)}</td>
					<td>${esc(r.difference_quantity ?? '')}</td>
					<td>${esc(r.attempt_number)}</td>
					<td>${esc(r.operator_name || '')}</td>
					<td>${esc(fmtDt(r.created_on))}</td>
					<td><span class="cb-badge ${badgeClass}">${esc(r.status)}</span></td>
					<td>${esc(r.resolved_by_name || '')}</td>
					<td>${esc(fmtDt(r.resolved_at))}</td>
					<td class="cb-note">${esc(r.resolution_note || '')}</td>
					<td>${blocked ? `
						<button type="button" class="button bn_release_countback"
							data-company-id="${esc(r.company_id)}"
							data-countback-id="${esc(r.id)}"
							title="Liberar continuidade"
							onclick="event.stopPropagation();window.__sialReleaseCountback&&window.__sialReleaseCountback(this.getAttribute('data-company-id'),this.getAttribute('data-countback-id'))">Liberar</button>
					` : ''}</td>
				</tr>`;
			}).join('') + `
			</tbody>
		</table>
	`;
}
